"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headers = exports.OssApi = void 0;
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
var _queryClientUtils = require("../util/queryClientUtils");
var _endpointHelpers = require("../util/endpointHelpers");
var _ossHelpers = require("../util/ossHelpers");
const headers = exports.headers = {
  "Content-Type": "application/json"
};
const origin = (0, _acsScWebPlatformApi.getApigeeUrl)();
const EXPIRATION_IN_MINUTES = 60;
const USE_CDN = true;
const OssApi = exports.OssApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getDownloadLink: async urn => {
      const url = (0, _ossHelpers.getUrlPathByEndpoint)(urn, "signeds3download");
      return await api.get("".concat(url, "?minutesExpiration=").concat(EXPIRATION_IN_MINUTES, "&useCdn=").concat(USE_CDN));
    },
    getUploadLink: async urn => {
      const url = (0, _ossHelpers.getUrlPathByEndpoint)(urn, "signeds3upload");
      const bucketData = await api.get(url);
      return bucketData;
    },
    uploadObject: async (url, dataToUpload, options) => {
      // The signed url contains auth token then we can't use the api which works with fetchWithToken
      await fetch(url, {
        method: "PUT",
        body: dataToUpload,
        signal: options === null || options === void 0 ? void 0 : options.signal
      });
      return;
    },
    finalizeUploadObject: async (urn, uploadKey) => {
      const url = (0, _ossHelpers.getUrlPathByEndpoint)(urn, "signeds3upload");
      return await api.create(url, {
        uploadKey
      });
    }
  };
}, {
  invalidateByQueryKeys: () => _queryClientUtils.NO_QUERIES_TO_INVALIDATE,
  basePath: "oss/v2",
  origin
});
//# sourceMappingURL=OssApi.js.map